import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';
import { ITumCredentialsFormValues } from '../../../../@types/model/masterData/tumCredentials/tumCredentialsFormValues';
import TumCredentialsModelHelper from '../../../../@types/model/masterData/tumCredentials/tumCredentialsModelHelper';
import { Icon, IconButton } from '@mui/material';

interface ITumCredentialsEditFormProps {
    isLoading : boolean;
    initialValues : ITumCredentialsFormValues;
    onSubmit : (values : ITumCredentialsFormValues) => void;
    onClose : () => void;
}

const TumCredentialsEditForm = (props : ITumCredentialsEditFormProps) : React.ReactElement => {

    const [showClientSecret, setShowClientSecret] = useState<boolean>(false);

    /*================================================================================================================
     *                                                  Queries
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Form
     * ==============================================================================================================*/

    const { handleSubmit, control, formState: { isValid, isDirty }, trigger } = useForm<ITumCredentialsFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(TumCredentialsModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    const onShowClientSecretClick = () => {
        setShowClientSecret(!showClientSecret);
    };

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p20 pt15 pb10'}>
                    <ControlledTextField
                        className={'mb10'}
                        control={control}
                        label={'Code'}
                        name={'code'}
                        defaultValue={props.initialValues.code}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10'}
                        control={control}
                        label={'Name'}
                        name={'name'}
                        defaultValue={props.initialValues.name}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10'}
                        control={control}
                        label={'Client Id'}
                        name={'clientId'}
                        defaultValue={props.initialValues.clientId}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb20'}
                        control={control}
                        label={'Client Secret'}
                        name={'clientSecret'}
                        defaultValue={props.initialValues.clientSecret}
                        size={'small'}
                        type={!showClientSecret ? 'password' : 'text'}
                        InputProps={{
                            endAdornment: (
                                <IconButton disabled={props.isLoading} onClick={onShowClientSecretClick}>
                                    <Icon>{!showClientSecret ? 'visibility' : 'visibility_off'}</Icon>
                                </IconButton>
                            ),
                        }}
                    />
                    <div className={'flx1 fdr jcfs'}>
                        <ControlledLabelledCheckBox
                            label={'Active?'}
                            name={'isActive'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe'}>
                        <Button className={'cpd mr20'} type={'button'} onClick={props.onClose}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={ !isDirty || !isValid || props.isLoading }
                        />
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default TumCredentialsEditForm;
